import React, {Component} from 'react';
import {connect} from 'react-redux'
import Form from '../forms/Form'
import {virszemesUdensObjektsKvalitateActions} from '../../actions/virszemesUdensObjektiActions'
import FormCard from "../forms/FormCard";
import Loading from "../Loading";
import {getDefaultTypeaheadOptionsFromKodifArray} from "../forms/FormHelpers";
import ExcelJS from 'exceljs';
import ExportSheetsButton from "../grid/ExportSheetsButton"
import {
    Row,
} from 'reactstrap'

const getExcelData = (dataList) => {

  const workbook = new ExcelJS.Workbook();

  const ekologiskaSheet = workbook.addWorksheet('Ekoloģiskās kvalitātes mērķi');

  const ekologiskaRows = dataList.filter(item => item.tips === 'Ekoloģiskā');

  ekologiskaSheet.columns = [
    { header: 'Nosaukums', key: 'nosaukums', width: 40 },
    { header: 'Vērtība', key: 'vertiba', width: 20 },
  ];

  ekologiskaRows.forEach(row => {
    ekologiskaSheet.addRow({
      nosaukums: row.nosaukums,
      vertiba: row.vertiba,
    });
  });

  const kimiskaSheet = workbook.addWorksheet('Ķīmiskās kvalitātes mērķis');

  const kimiskaRows = dataList.filter(item => item.tips === 'Ķīmiskā');

  kimiskaSheet.columns = [
    { header: 'Vērtība', key: 'vertiba', width: 30 },
  ];

  kimiskaRows.forEach(row => {
    kimiskaSheet.addRow({
      vertiba: row.vertiba,
    });
  });

  const aizsargajamoSheet = workbook.addWorksheet('Aizsargājamo teritoriju mērķi');

  const aizsargajamoRows = dataList.filter(item => item.tips === 'NĪJT' || item.tips === 'PZŪ');

  aizsargajamoSheet.columns = [
    { header: 'Tips', key: 'tips', width: 15 },
    { header: 'Nosaukums', key: 'nosaukums', width: 30 },
    { header: 'Mērvienība', key: 'mervieniba', width: 20 },
    { header: 'Vērtība', key: 'vertiba', width: 20 },
  ];

  aizsargajamoRows.forEach(row => {
    aizsargajamoSheet.addRow({
      tips: row.tips,
      nosaukums: row.nosaukums,
      mervieniba: row.mervieniba,
      vertiba: row.vertiba,
    });
  });

  const iadtSheet = workbook.addWorksheet('ĪADT mērķi');

  const iadtRows = dataList.filter(item => item.tips === 'ĪADT');

  iadtSheet.columns = [
    { header: 'Vērtība', key: 'vertiba', width: 30 },
  ];

  iadtRows.forEach(row => {
    iadtSheet.addRow({
      vertiba: row.vertiba,
    });
  });

  return workbook;
};


class KvalitateComp extends Component {

    getFormFieldWrapperCfgs = () => {
        return [
            {
                id: 'eko_wrap',
                comp: FormCard,
                compProps: {
                    title: 'Ekoloģiskās kvalitātes mērķi',
                    pinnable: true,
                    size: 12
                },
            },
            {
                id: 'kimiska_wrap',
                comp: FormCard,
                compProps: {
                    title: 'Ķīmiskās kvalitātes mērķis',
                    pinnable: true,
                    size: 12
                },
            },
            {
                id: 'aizsargajamo_wrap',
                comp: FormCard,
                compProps: {
                    title: 'Aizsargājamo teritoriju mērķi',
                    pinnable: true,
                    size: 12
                },
            },
            {
                id: 'iadt_wrap',
                comp: FormCard,
                compProps: {
                    title: 'ĪADT mērķi',
                    pinnable: true,
                    size: 12
                },
            }
        ]
    }

    getFormFieldCfgs = ({kodif, user}) => {
        return [
        {
            name: 'Ekoloģiskās kvalitātes mērķi',
            label: false,
            sizeLabel: 0,
            sizeForm: 12,
            fieldWrapper: 'eko_wrap',
            type: 'multiField',
            editable: false,
            multiFieldCfgs:[{
                name: 'nosaukums',
                label: false
            },
            {
                name: 'vertiba',
                label: false
            },
            ],
            renderer: (val, rows) => {
                const list = rows?.uo_kvalitates_merki || [];
                const ekologiskaRows = list.filter(r => r?.tips === 'Ekoloģiskā');
                return (
                    <table className="table table-bordered table-sm">
                        <tbody>
                            {ekologiskaRows.map((r, index) => (
                                <tr key={r.id || index}>
                                    <td>{r.nosaukums || ''}</td>
                                    <td>{r.vertiba || ''}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                );
            }
        },
        {
            name: 'vertiba',
            fieldWrapper: 'kimiska_wrap',
            label: false,
            renderer: (val, rows) => {
                const list = rows?.uo_kvalitates_merki || [];
                const kimiskaRows = list.filter(r => r?.tips === 'Ķīmiskā');
                return kimiskaRows.map((r, index) => (
                    <div key={r.id || index}>{r.vertiba || ''}</div>
                ));
            },
        },
        {
            name: 'Aizsargājamo teritoriju mērķi',
            label: false,
            sizeLabel: 0,
            sizeForm: 12,
            fieldWrapper: 'aizsargajamo_wrap',
            editable: false,
            multiFieldCfgs:[{
                name: 'tips',
                label: false
            },
            {
                name: 'nosaukums',
                label: false
            },
            {
                name: 'mervieniba',
                label: false
            },
            {
                name: 'vertiba',
                label: false
            },
            ],
            renderer: (val, rows) => {
                const list = rows?.uo_kvalitates_merki || [];
                const nijtRow = list.find(r => r?.tips === 'NĪJT');
                const pzuRows = list.filter(r => r?.tips === 'PZŪ') || [];

                return (
                    <table className="table table-bordered table-sm">
                        <tbody>
                            {nijtRow && (
                                <tr>
                                    <td>NĪJT</td>
                                    <td>{nijtRow.nosaukums || ''}</td>
                                    <td>{nijtRow.mervieniba || ''}</td>
                                    <td>{nijtRow.vertiba || ''}</td>
                                </tr>
                            )}
                            {pzuRows.map((r, index) => (
                                <tr key={index}>
                                    {index === 0 && (
                                        <td rowSpan={pzuRows.length} style={{ verticalAlign: 'top' }}>
                                            PZŪ
                                        </td>
                                    )}
                                    <td>{r.nosaukums || ''}</td>
                                    <td>{r.mervieniba || ''}</td>
                                    <td>{r.vertiba || ''}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                );
            }
        },
        {
            name: 'vertiba',
            fieldWrapper: 'iadt_wrap',
            label: false,
            renderer: (val, rows) => {
                const list = rows?.uo_kvalitates_merki || [];
                const iadtRows = list.filter(r => r?.tips === 'ĪADT');
                return iadtRows.map((r, index) => (
                    <div key={r.id || index}>{r.vertiba || ''}</div>
                ));
            },
        },
        ]}


render() {
  const {
    virszemesUdensObjektsKvalitate,
    user,
    getFormFieldCfgsFunc,
    kodif,
    getFormFieldWrapperCfgsFunc,
    metadata
  } = this.props;

  const { selectedItem } = virszemesUdensObjektsKvalitate;

  if (!selectedItem) {
    return <Loading />;
  }

  const periodsValues = getDefaultTypeaheadOptionsFromKodifArray(kodif, 'UO_PERIODS').map(v => v.tah_id);
  const currentPeriodsIndex = periodsValues.indexOf(selectedItem.periods);

  const onNextPrevYear = (periods) => {
      this.props.fetchAct({ ...selectedItem, periods });
  }

  const nextYear = () => periodsValues[currentPeriodsIndex + 1];
  const prevYear = () => periodsValues[currentPeriodsIndex - 1];

  if (!this.formFieldCfgs) {
    const f = getFormFieldCfgsFunc || this.getFormFieldCfgs;
    this.formFieldCfgs = f({ kodif, user });
  }

  if (!this.formFieldWrapperCfgs) {
    const f = getFormFieldWrapperCfgsFunc || this.getFormFieldWrapperCfgs;
    this.formFieldWrapperCfgs = f();
  }

    const exportBtn = (
      <ExportSheetsButton
        sheetsData={getExcelData(selectedItem.uo_kvalitates_merki || [], this.formFieldCfgs, metadata)}
        filename={`virszemes_kvalitates_data_${selectedItem.periods}_${selectedItem.kods}`}
      />
    );


  return (
    <div className="form-container">
      <div className="atradne-title uo-gads d-flex flex-row-reverse">
        <h4 className="num-periods">
          <i className="fa fa-caret-left" title={prevYear()} onClick={() => onNextPrevYear(prevYear())}></i>
          <span>{selectedItem.periods}</span>
          <i className="fa fa-caret-right" title={nextYear()} onClick={() => onNextPrevYear(nextYear())}></i>
        </h4>
      </div>
      <Form
        editable={false}
        dataObj={selectedItem}
        formFieldCfgs={this.formFieldCfgs}
        formFieldWrapperCfgs={this.formFieldWrapperCfgs}
        onSubmit={this.props.saveAct}
        onReset={this.props.stopEditAct}
        onStartEdit={this.props.startEditAct}
        formWrapperComp={Row}
        metadataFormCfg="kvalitates_merki"
        extraElements={exportBtn}
      />
    </div>
  );
}

}

const mapStateToProps = ({ virszemesUdensObjektsKvalitate, kodif, metadata, user }) => ({
  virszemesUdensObjektsKvalitate,
  kodif,
  metadata,
  user
});

const VirszemesKvalitate = connect(mapStateToProps, {
    ...virszemesUdensObjektsKvalitateActions
})(KvalitateComp);
export default VirszemesKvalitate